(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["belyr-mobile-menu"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeBelyrMobileMenu = () => {
      const trigger = document.querySelector('[data-belyr-mobile-menu-trigger]');
      const drawer = document.querySelector('[data-belyr-mobile-menu]');
      const overlay = document.querySelector('[data-belyr-mobile-menu-overlay]');
      const closeButton = drawer?.querySelector('[data-belyr-mobile-menu-close]');

      if (!trigger || !drawer || !overlay || !closeButton || drawer.dataset.initialized === 'true') return;

      drawer.dataset.initialized = 'true';
      const mobileViewport = window.matchMedia('(max-width: 900px)');
      const accordionItems = Array.from(drawer.querySelectorAll('.belyr-mobile-menu__details'));
      let isOpen = false;
      let previousFocus = null;

      const setOpen = (open) => {
        if (open && !mobileViewport.matches) return;

        isOpen = open;
        drawer.classList.toggle('is-open', open);
        overlay.classList.toggle('is-open', open);
        drawer.setAttribute('aria-hidden', String(!open));
        trigger.setAttribute('aria-expanded', String(open));
        trigger.setAttribute('aria-label', open ? 'Stäng meny' : 'Öppna meny');
        document.body.classList.toggle('belyr-mobile-menu-open', open);

        if (open) {
          previousFocus = document.activeElement;
          closeButton.focus({ preventScroll: true });
        } else if (previousFocus instanceof HTMLElement) {
          previousFocus.focus({ preventScroll: true });
        }
      };

      const handleKeydown = (event) => {
        if (!isOpen) return;

        if (event.key === 'Escape') {
          event.preventDefault();
          setOpen(false);
          return;
        }

        if (event.key !== 'Tab') return;

        const focusable = Array.from(
          drawer.querySelectorAll('a[href], button:not([disabled]), summary, input:not([disabled])')
        ).filter((element) => element.getClientRects().length > 0);

        if (!focusable.length) return;

        const first = focusable[0];
        const last = focusable[focusable.length - 1];

        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      };

      trigger.addEventListener('click', () => setOpen(!isOpen));
      closeButton.addEventListener('click', () => setOpen(false));
      overlay.addEventListener('click', () => setOpen(false));
      accordionItems.forEach((item) => {
        item.addEventListener('toggle', () => {
          if (!item.open) return;

          accordionItems.forEach((otherItem) => {
            if (otherItem !== item) otherItem.open = false;
          });
        });
      });
      document.addEventListener('keydown', handleKeydown);
      mobileViewport.addEventListener('change', (event) => {
        if (!event.matches) setOpen(false);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeBelyrMobileMenu, { once: true });
    } else {
      initializeBelyrMobileMenu();
    }

    document.addEventListener('shopify:section:load', initializeBelyrMobileMenu);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["belyr-policy-pages"] && !Shopify.designMode) return;
  try {
    const hidePolicyUpdateDates = () => {
    document.querySelectorAll('.shopify-policy__body .rte p').forEach((paragraph) => {
      const text = paragraph.textContent.trim().toLocaleLowerCase('sv-SE');

      if (text.startsWith('senast uppdaterad') || text.startsWith('last updated')) {
        paragraph.hidden = true;
      }
    });
  };

  const isCookiePreferencesTrigger = (element) => {
    const label = `${element.textContent || ''} ${element.getAttribute('aria-label') || ''}`.toLocaleLowerCase('sv-SE');
    const href = (element.getAttribute('href') || '').toLocaleLowerCase('sv-SE');

    return label.includes('cookieinställ')
      || label.includes('cookie-inställ')
      || label.includes('kakinställ')
      || label.includes('cookie settings')
      || label.includes('cookie preferences')
      || href.includes('cookie-settings')
      || href.includes('cookie-preferences')
      || href.includes('cookie_settings')
      || href.includes('cookie_preferences')
      || href.includes('cookie-consent');
  };

  const openCookiePreferences = () => {
    if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
      Promise.resolve(window.privacyBanner.showPreferences()).catch(() => {
        window.location.assign('/policies/privacy-policy');
      });
      return;
    }

    window.location.assign('/policies/privacy-policy');
  };

  const findCookiePreferencesTrigger = (event) => {
    const path = typeof event.composedPath === 'function' ? event.composedPath() : [];

    for (const node of path) {
      if (node instanceof Element && node.matches('a, button') && isCookiePreferencesTrigger(node)) {
        return node;
      }
    }

    if (!(event.target instanceof Element)) return null;

    const closestTrigger = event.target.closest('a, button');
    return closestTrigger && isCookiePreferencesTrigger(closestTrigger) ? closestTrigger : null;
  };

  const handleCookiePreferencesClick = (event) => {
    const trigger = findCookiePreferencesTrigger(event);
    if (!trigger) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    openCookiePreferences();
  };

  const normalizeCookiePreferencesTriggers = (root = document) => {
    if (!(root instanceof Document || root instanceof Element)) return;

    root.querySelectorAll('a, button').forEach((element) => {
      if (!isCookiePreferencesTrigger(element)) return;

      element.setAttribute('data-belyr-cookie-preferences', 'true');

      if (element.matches('a')) {
        element.setAttribute('href', '#cookie-preferences');
      }
    });
  };

  const initializePolicyPageEnhancements = () => {
    hidePolicyUpdateDates();
    normalizeCookiePreferencesTriggers();

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof Element)) return;

          if (node.matches('a, button') && isCookiePreferencesTrigger(node)) {
            node.setAttribute('data-belyr-cookie-preferences', 'true');

            if (node.matches('a')) {
              node.setAttribute('href', '#cookie-preferences');
            }
          }

          normalizeCookiePreferencesTriggers(node);
        });
      });
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  };

  window.addEventListener('click', handleCookiePreferencesClick, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializePolicyPageEnhancements, { once: true });
  } else {
    initializePolicyPageEnhancements();
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["belyr-product-visual-system"] && !Shopify.designMode) return;
  try {
    (() => {
    const formSelector = '.belyr-home .bh-product-card form[data-type="add-to-cart-form"]';
    const cartUpdateEventName = 'shopify:cart:lines-update';

    const refreshCartComponents = async () => {
      const components = Array.from(document.querySelectorAll('cart-items-component'));
      if (!components.length) return;

      await customElements.whenDefined('cart-items-component');
      await Promise.all(
        components.map((component) =>
          typeof component.fetchCartData === 'function' ? component.fetchCartData() : Promise.resolve()
        )
      );
    };

    const getCart = async (routesRoot) => {
      const response = await fetch(`${routesRoot}cart.js`, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      });

      if (!response.ok) throw new Error('Varukorgen kunde inte uppdateras.');
      return response.json();
    };

    const addProductWithoutNavigation = async (form) => {
      if (form.dataset.belyrSubmitting === 'true') return;

      const variantInput = form.querySelector('input[name="id"]');
      const quantityInput = form.querySelector('input[name="quantity"]');
      const variantId = variantInput?.value?.trim();
      const quantity = Math.max(Number.parseInt(quantityInput?.value || '1', 10) || 1, 1);
      const button = form.querySelector('button[type="submit"], input[type="submit"], button:not([type])');
      const component = form.closest('product-form-component');
      const liveRegion = component?.querySelector('[ref="liveRegion"]');

      if (!variantId || !/^\d+$/.test(variantId) || !button || button.disabled) return;

      const routesRoot = window.Shopify?.routes?.root || '/';
      const item = { id: Number(variantId), quantity };
      form.dataset.belyrSubmitting = 'true';
      button.setAttribute('aria-busy', 'true');
      button.classList.add('is-loading');
      if (liveRegion) liveRegion.textContent = 'Lägger produkten i varukorgen…';

      const updatePromise = (async () => {
        const addResponse = await fetch(`${routesRoot}cart/add.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ items: [item] }),
        });

        if (!addResponse.ok) {
          const error = await addResponse.json().catch(() => ({}));
          throw new Error(error.description || 'Produkten kunde inte läggas i varukorgen.');
        }

        const drawer = document.getElementById('cart-drawer');
        if (window.Shopify?.actions?.openCart) {
          window.Shopify.actions.openCart();
        } else if (typeof drawer?.open === 'function') {
          drawer.open();
        }

        await new Promise((resolve) => requestAnimationFrame(resolve));
        await refreshCartComponents();
        const cart = await getCart(routesRoot);

        return {
          cart,
          detail: {
            didError: false,
            itemCount: quantity,
            items: cart.items,
            source: 'belyr-home-product-card',
            sourceId: variantId,
          },
        };
      })();

      const cartEvent = new CustomEvent(cartUpdateEventName, { bubbles: true });
      Object.defineProperties(cartEvent, {
        action: { value: 'add' },
        context: { value: 'product' },
        lines: { value: [{ merchandiseId: variantId, quantity }] },
        promise: { value: updatePromise },
      });
      button.dispatchEvent(cartEvent);

      try {
        await updatePromise;
        if (liveRegion) liveRegion.textContent = 'Produkten har lagts i varukorgen.';
      } catch (error) {
        if (liveRegion) {
          liveRegion.textContent = error.message || 'Produkten kunde inte läggas i varukorgen. Försök igen.';
        }
      } finally {
        delete form.dataset.belyrSubmitting;
        button.removeAttribute('aria-busy');
        button.classList.remove('is-loading');
      }
    };

    const interceptHomeProductForm = (event, form) => {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      addProductWithoutNavigation(form);
    };

    document.addEventListener(
      'click',
      (event) => {
        if (!(event.target instanceof Element)) return;

        const button = event.target.closest(
          '.belyr-home .bh-product-card form[data-type="add-to-cart-form"] button[type="submit"], .belyr-home .bh-product-card form[data-type="add-to-cart-form"] input[type="submit"], .belyr-home .bh-product-card form[data-type="add-to-cart-form"] button:not([type])'
        );
        const form = button?.closest(formSelector);
        if (!form || button.disabled) return;

        interceptHomeProductForm(event, form);
      },
      true
    );

    document.addEventListener(
      'submit',
      (event) => {
        if (!(event.target instanceof HTMLFormElement) || !event.target.matches(formSelector)) return;
        interceptHomeProductForm(event, event.target);
      },
      true
    );
  })();
  } catch(e) { console.error(e); }
})();

})();
